
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[appName]/login",
      function () {
        return require("private-next-pages/[appName]/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[appName]/login"])
      });
    }
  